import axios from "axios";

axios.defaults.headers = {
  // Accept: "application/json",
  "Content-Type": "application/json",
  Cookie: "JSESSIONID=2761C69C1ABA77B476896657AA7F3661.node1",
};

export const sarvahAxios = axios.create({
  // baseURL: process.env.REACT_APP_BACKEND_URL,
  baseURL: "https://www.manipalcigna.com/o/revamp/home",
});

sarvahAxios.interceptors.request.use(
  async (config) => {
    // config.headers["Access-Control-Allow-Origin"] = "*";
    // config.headers["Cookie"] =
    //   "JSESSIONID=2761C69C1ABA77B476896657AA7F3661.node1";
    return config;
  },
  (error) => Promise.reject(error)
);
